<template>
  <p>
    {{ text('context_info.CAVERNS.p1') }}
  </p>
  <p>
    {{ text('context_info.CAVERNS.p2') }}
  </p>
  <hr />
  <div class="mt-3">
    <span class="text-green-400">***{{ text('context_info.CAVERNS.legend.title') }}*** </span>
    <ul class="px-10">
      <li><span class="font-bold text-2xl mr-6">&gt;</span>{{ text('context_info.CAVERNS.legend.>') }}</li>
      <li><span class="font-bold text-2xl mr-6">&lt;</span>{{ text('context_info.CAVERNS.legend.<') }}</li>
      <li><span class="font-bold text-2xl mr-6">/</span>{{ text('context_info.CAVERNS.legend./') }}</li>
      <li><span class="font-bold text-2xl mr-6" style="color: #d761ff;">Ω</span>{{ text('context_info.CAVERNS.legend.Ω') }}</li>
      <li><span class="font-bold text-2xl mr-6">7, ^, ", }, 0, %, ], `, ?, /, (, ~, ;</span>{{ text('context_info.CAVERNS.legend.equipment_drops') }}</li>
      <li><span class="font-bold text-2xl mr-6" style="color: #20bcff;">*</span>{{ text('ui.pixie_dust') }}</li>
      <li><span class="font-bold text-2xl mr-6" style="color: #fbd700;">$</span>{{ text('ui.gold') }}</li>
      <li><span class="font-bold text-2xl mr-6">&</span>{{ text('context_info.CAVERNS.legend.pile_of_loot') }}</li>
    </ul>
  </div>
  <hr />
  <p class="mt-3">
    <span>{{ text('context_info.CAVERNS.loot_is_auto_gathered') }}</span>
  </p>
  <hr />
  <p class="mt-3">
    <span>{{ text('context_info.CAVERNS.game_runs_in_bg') }}</span>
  </p>
</template>

<script setup>
import text from '~/text';
</script>
